import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class FactureFBService {

    create(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/facture-fbs`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    validate(idFactureFB) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/facture-fbs/validate/${idFactureFB}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    update(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.put(`${api_url}/facture-fbs/${data?.idFactureFB}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    remove(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.delete(`${api_url}/facture-fbs/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    view(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/facture-fbs/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    validateEtiquetage(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/facture-fbs/validate-etiquetage/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    viewAll() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/facture-fbs`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }



}

export default new FactureFBService()